import React, { useEffect, useMemo } from "react";
import Form from "../../components/Form";
import { Controller, useForm } from "react-hook-form";
import { makeStyles } from "../../utils/styles";
import { yupResolver } from "@hookform/resolvers/yup";
import { FORM } from "../../utils/constans";
import * as yup from "yup";
import Paper from "../../components/Paper";
import Input from "../../components/Input";
import Divider from "../../components/Divider";
import Typography from "../../components/Typography";
import ButtonGroup from "../../components/ButtonGroup";
import Button from "../../components/Button";
import InputTags from "../../components/InputTags";
import Icon from "../../components/Icon";
import PropTypes from "prop-types";
import { useTheme } from "styled-components";
import { Col, Row } from "react-styled-flexboxgrid";
import FormError from "../../components/FormError";
import FormLabel from "../../components/FormLabel";
import { preventDefault } from "../../utils/helpers";
import Loader from "../../components/Loader";
import { useTranslation } from "react-i18next";
import Select from "../../components/Select";

const useStyles = makeStyles((css) => ({
    paper: css`
        position: relative;
        overflow: hidden;
        padding: 40px 40px 15px 40px;
        width: 680px;
    `,
    title: css`
        margin-bottom: 35px;
    `,
    skillsTitle: css`
        margin-bottom: 30px;
    `,
    divider: css`
        margin: 25px 0;
    `,
    skillsDivider: css`
        margin: 10px 0 15px 0;
    `,
    buttons: css`
        display: flex;
        justify-content: flex-end;
    `,
    noMarginBottom: css`
        margin-bottom: 0;
    `,
}));

const schema = yup.object().shape({
    name: yup.string().required(FORM.FIELD_IS_REQUIRED),
    language:  yup.string(),
    hourly_rate_user: yup
        .number()
        .typeError(FORM.FIELD_IS_REQUIRED)
        .required(FORM.FIELD_IS_REQUIRED),
    hourly_rate_admin: yup
        .number()
        .typeError(FORM.FIELD_IS_REQUIRED)
        .required(FORM.FIELD_IS_REQUIRED),
    skills_ids: yup
        .array()
        .typeError(FORM.FIELD_IS_REQUIRED)
        .required(FORM.FIELD_IS_REQUIRED),
});

const getPreloadedValues = () => ({
    skills_ids: [],
    language: "pl_PL"
});

const FormProfession = ({ loading, edit, skillsHints, initialValues, onSubmit, onClickCancel }) => {
    const { t } = useTranslation()
    const styles = useStyles();
    const theme = useTheme();

    const {
        register,
        watch,
        handleSubmit,
        errors,
        control,
        getValues,
        setValue,
        setError,
        clearErrors,
    } = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            ...getPreloadedValues(),
            ...initialValues,
        },
    });

    const watchSkillsIds = watch("skills_ids");
    console.log(watch())
    console.log({initialValues})
    useEffect(() => {
        register({ name: "skills_ids" });
    }, [register]);

    const handleClickAddSkill = (value) => {
        if (value.tag) {
            const skillsIds = getValues("skills_ids");
            setValue("skills_ids", [...skillsIds, value.tag?.id]);
            clearErrors("skills_ids");
        } else if (value.error && value.message) {
            setError("skills_ids", {
                type: "manual",
                message: value.message,
            });
        }
    };

    const handleClickDeleteSkill = (skill) => {
        const skillsIds = getValues("skills_ids");
        setValue(
            "skills_ids",
            skillsIds.filter((skillID) => skillID !== skill.id)
        );
    };

    const handleClickDeleteAllSkills = () => {
        setValue("skills_ids", []);
    };

    const skills = useMemo(() => {
        if (!!!skillsHints || watchSkillsIds.length === 0) return [];
        return skillsHints.filter(
            (skill) => !!watchSkillsIds.find((skillID) => skillID === skill.id)
        );
    }, [skillsHints, watchSkillsIds]);

    return (
        <Paper customStyle={styles.paper}>
            <Form onSubmit={preventDefault}>
                <Typography customStyle={styles.title} as="h1">
                    {edit ? t("Edytuj zawód") : t("Dodaj zawód")}
                </Typography>
                <Divider customStyle={styles.divider} />
                <Input
                    type="text"
                    ref={register}
                    name="name"
                    label={t("Nazwa zawodu")}
                    placeholder={t("Nazwa zawodu")}
                    error={!!errors.name}
                    errorText={errors.name?.message}
                />
                <Controller
                    control={control}
                    name="language"
                    render={({ onChange, value }) => (
                        <Select
                            label={t("Język")}
                            placeholder="Wybierz"
                            value={value}
                            onChange={onChange}
                            options={[
                                { label: "Polski", value: "pl_PL" },
                                { label: "Angielski", value: "en_US" },
                            ]}
                            fullWidth
                        />
                    )}
                />
                <Row between="xs">
                    <Col xs={5}>
                        <Row bottom="xs">
                            <Col xs={12}>
                                <FormLabel>
                                    {t("Stawka godzinowa dla kandydata")}
                                </FormLabel>
                            </Col>
                            <Col xs={6}>
                                <Input
                                    type="number"
                                    ref={register}
                                    name="hourly_rate_user"
                                    placeholder={t("Stawka")}
                                    customStyle={styles.noMarginBottom}
                                    error={!!errors.hourly_rate_user}
                                />
                            </Col>
                            <Col xs={6}>
                                <Input
                                    value="brutto"
                                    readonly
                                    customStyle={styles.noMarginBottom}
                                />
                            </Col>
                            {!!errors.hourly_rate_user && (
                                <Col xs={12}>
                                    <FormError>
                                        {errors.hourly_rate_user?.message}
                                    </FormError>
                                </Col>
                            )}
                        </Row>
                    </Col>
                    <Col xs={5}>
                        <Row bottom="xs">
                            <Col xs={12}>
                                <FormLabel>
                                    {t("Stawka godzinowa dla obiektu")}
                                </FormLabel>
                            </Col>
                            <Col xs={6}>
                                <Input
                                    type="number"
                                    ref={register}
                                    name="hourly_rate_admin"
                                    placeholder={t("Stawka")}
                                    customStyle={styles.noMarginBottom}
                                    error={!!errors.hourly_rate_admin}
                                />
                            </Col>
                            <Col xs={6}>
                                <Input
                                    value="brutto"
                                    readonly
                                    customStyle={styles.noMarginBottom}
                                />
                            </Col>
                            {!!errors.hourly_rate_admin && (
                                <Col xs={12}>
                                    <FormError>
                                        {errors.hourly_rate_admin?.message}
                                    </FormError>
                                </Col>
                            )}
                        </Row>
                    </Col>
                </Row>
                <Divider customStyle={styles.divider} />
                <Typography font={theme.fonts.mulishBold} as="h2" customStyle={styles.skillsTitle}>
                    {t("Umiejętności")}
                </Typography>
                <InputTags
                    placeholder={t("Wpisz umiejętność i naciśnij Enter")}
                    tags={skills}
                    tagsHints={skillsHints}
                    enableEnterKeyDown
                    enableDeleteAll={skills.length > 0}
                    useHintsToFindTag
                    onClickAdd={handleClickAddSkill}
                    onClickDelete={handleClickDeleteSkill}
                    onClickDeleteAll={handleClickDeleteAllSkills}
                    onEnterKeyDown={handleClickAddSkill}
                    error={!!errors.skills_ids}
                    errorText={errors.skills_ids?.message}
                />
                <Divider customStyle={styles.skillsDivider} />
                <ButtonGroup customStyle={styles.buttons}>
                    <Button onClick={onClickCancel} variant="text" startIcon={<Icon name="close" width={12} height={12} />}>
                        {t("Anuluj")}
                    </Button>
                    <Button
                        onClick={handleSubmit(onSubmit)}
                        startIcon={
                            !edit ? (
                                <Icon
                                    name="add"
                                    width={12}
                                    height={12}
                                    fill={theme.colors.white}
                                />
                            ) : (
                                <Icon
                                    name="save"
                                    width={14}
                                    height={14}
                                    fill={theme.colors.white}
                                />
                            )
                        }
                        disabled={loading}
                    >
                        {edit ? t("Zapisz") : t("Dodaj zawód")}
                    </Button>
                </ButtonGroup>
            </Form>
            <Loader show={loading} />
        </Paper>
    );
};

FormProfession.propTypes = {
    loading: PropTypes.bool,
    edit: PropTypes.bool,
    skillsHints: PropTypes.array,
    initialValues: PropTypes.object,
    onSubmit: PropTypes.func,
    onClickCancel: PropTypes.func,
};

export default FormProfession;
